import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaNomeCurso = (): TabelaColuna => ({
  Chave: 'nomeCursoTurma',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 200 }}>Nome Curso</div>
})
